import { Component, Input, TemplateRef } from '@angular/core';
import { PluginNavigationService } from '@anecdotes/plugins-connection';

@Component({
  selector: 'app-navigate-to-plugin',
  templateUrl: './navigate-to-plugin.component.html',
  standalone: false,
})
export class NavigateToPluginComponent {
  @Input()
  icon: string;

  @Input()
  translationKey: string;

  @Input()
  pluginId: string;

  @Input()
  disabled?: boolean;

  @Input()
  disableTooltip?: TemplateRef<any>;

  constructor(private pluginsNavigationService: PluginNavigationService) {}

  navigateToPlugin(): void {
    this.pluginsNavigationService.navigateToPluginDetailsInNewTab(this.pluginId);
  }
}
